import { useState, useRef, useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';

import classes from 'app/components/Form/classes.module.scss';
import UploadWorker from 'app/workers/UploadWorker';

const FilePreview = props => {
  const {
    file
  } = props;

  const imgRef = useRef();

  const uploadWorker = useContext(UploadWorker);

  useEffect(() => {
    uploadWorker.createObjectURL(file, url => {
      imgRef.current.src = url;
      imgRef.current.style.display = 'inline';
    });
  }, []);

  return <img ref={imgRef} alt={file.name} style={{display: 'none'}}></img>;
}

const FilePicker = props => {
  const {
    accept,
    multiple,
    inputProps,
    onFilesSelected
  } = props;

  const [files, setFiles] = useState([]);
  const inputRef = useRef();
  const openFilePicker = () => inputRef.current?.click();

  const onChange = event => {
    onFilesSelected(event.target.files);
    setFiles(Array.from(event.target.files).slice(0, 7));
  }

  // setup dummy value to animate TextField label
  inputProps.value = files.length ? ' ' : '';

  let thumbnails = files.map((file, index) => (
    <FilePreview
      key={`${inputProps.key}-${index}`}
      file={file}
    />
  ));

  return (
    <div className={classes.filePicker}>
      <input ref={inputRef} type="file" style={{display: 'none'}} accept={accept} multiple={multiple} onChange={onChange} />
      <TextField {...inputProps} />
      <div className={classes.filePickerPreview} onClick={openFilePicker}>
        {thumbnails}
      </div>
    </div>
  );
}

export default FilePicker;
